import { parseRdfQuadsWithJsonLd } from "../jsonld/jsonld-adapter.js";
import { parseRdfQuadsWithN3 } from "../n3/n3-adapter.js";
import { parseRdfXml } from "../xml/rdfxml-adapter.js";
var MimeType;
(function (MimeType) {
    MimeType["JsonLd"] = "application/ld+json";
    MimeType["NQuads"] = "application/n-quads";
    MimeType["Turtle"] = "text/turtle";
    MimeType["TriG"] = "application/trig";
    MimeType["NTriples"] = "application/n-triples";
    MimeType["RdfXML"] = "application/rdf+xml";
})(MimeType || (MimeType = {}));
export async function fetchRdfQuads(httpFetch, url, asMimeType) {
    const options = {
        headers: {
            Accept: supportedTypes().join(","),
        },
    };
    const response = await httpFetch(url, options);
    const contentType = getContentType(response);
    switch (asMimeType ?? contentType) {
        case MimeType.JsonLd:
            return await parseRdfQuadsWithJsonLd(await response.text());
        case MimeType.NQuads:
        case MimeType.Turtle:
        case MimeType.TriG:
        case MimeType.NTriples:
            return await parseRdfQuadsWithN3(await response.text());
        case MimeType.RdfXML:
            return await parseRdfXml(await response.text());
        default:
            throw new Error(`Unsupported format '${contentType}'`);
    }
}
function supportedTypes() {
    return [
        MimeType.JsonLd,
        MimeType.NQuads,
        MimeType.Turtle,
        MimeType.TriG,
        MimeType.NTriples,
        MimeType.RdfXML,
    ];
}
function getContentType(response) {
    if (!response.headers.has("content-type")) {
        //throw Error("Missing 'content-type' header.");
        return MimeType.Turtle; // Fallback to default
    }
    const value = response.headers.get("content-type").toLowerCase();
    const index = value.indexOf(";");
    return index === -1 ? value : value.substr(0, index);
}
//# sourceMappingURL=http-adapter.js.map